var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnTutorialText = function SvgIcnTutorialText(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 18,
    viewBox: "0 0 62 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4396_257874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01412 4.66387C8.41689 2.09675 11.109 0.5 14.0344 0.5H62L54.9859 13.3361C53.5831 15.9033 50.891 17.5 47.9656 17.5H0L7.01412 4.66387Z",
    fill: "#753BBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.729 13.88V10.734H17.753V13.88H19.029V10.734H21.185V9.7H12.33V10.734H14.453V13.88H15.729ZM19.854 7.247V6.224H14.739V5.553H20.085V4.519H13.463V8.93H20.162V7.918H14.739V7.247H19.854ZM29.6906 9.953V8.93H24.2566V7.874H29.2726V6.862H24.2566V5.773H29.6026V4.75H22.9696V9.953H25.6096V11.625H21.8476V12.637H30.7026V11.625H26.8966V9.953H29.6906ZM38.1852 4.068V13.869H39.4612V4.068H38.1852ZM37.3272 10.283C36.0732 10.514 34.1262 10.569 33.1912 10.569V8.578H36.3922V4.904H31.8712V5.927H35.0942V7.555H31.9152V11.625H32.9492C34.6102 11.625 36.4362 11.515 37.4702 11.306L37.3272 10.283ZM48.9787 8.974V4.068H47.7027V6.07H46.3827V7.104H47.7027V8.974H48.9787ZM49.2867 13.792V12.769H43.8417V12.098H48.9787V9.469H42.4887V10.492H47.7027V11.163H42.5327V13.792H49.2867ZM40.9377 6.686C40.9377 8.028 42.0707 8.864 43.4677 8.864C44.9307 8.864 45.9977 7.995 45.9977 6.686C45.9977 5.355 44.9307 4.409 43.4677 4.409C42.0157 4.409 40.9377 5.366 40.9377 6.686ZM42.1917 6.675C42.1917 6.004 42.7747 5.476 43.4677 5.476C44.2487 5.476 44.7437 6.004 44.7437 6.675C44.7437 7.269 44.2377 7.808 43.4677 7.808C42.7197 7.808 42.1917 7.324 42.1917 6.675Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4396_257874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 18,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnTutorialText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_tutorial_text.0603ff68.svg";
export { ForwardRef as ReactComponent };